module.exports = __webpack_public_path__ + "img/my_refers.6aff1697.png";